export enum SectionColor {
    BLACK = 'BLACK',
    WHITE = 'WHITE',
    YELLOW = 'YELLOW'
}

export enum SectionMinHeight {
    FULL = 'FULL',		// full screen height
    LARGE = 'LARGE',	// 75% screen heigh
}
